module.exports = __webpack_public_path__ + "img/one-bg.10ec0936.jpeg";